// extracted by mini-css-extract-plugin
export var activeDot = "_31-c";
export var buttonContainer = "_31-9";
export var channelButton = "_31-a";
export var clickable = "_31-d";
export var content = "_31-0";
export var contentFull = "_31-2";
export var contentThird = "_31-1";
export var contentWrapper = "_31-7";
export var description = "_31-5";
export var heightShort = "_31-f";
export var image = "_31-3";
export var imageContainer = "_31-4";
export var selectButton = "_31-e";
export var spinnerContainer = "_31-b";
export var titleContent = "_31-8";
export var titleWrapper = "_31-6";